module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-b99cbdbe.svg";